import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import styled from 'styled-components/macro';
import { WxLabel, WxSelector, WxText } from '../components';
import { AddressDisplay } from '../components/ui/address/AddressDisplay';
import { AddressForm } from '../components/ui/address/AddressForm';
import { CustomNav } from '../components/ui/customNav/CustomNav';
import { OrderBar } from '../components/ui/orderBar/OrderBar';
import { useAddressContext } from '../hooks/context/useAddressContext';
import { useCartContext } from '../hooks/context/useCartContext';
import { __ } from '../i18n/l10n';
import { breakpoint } from '../styles/constants';
import { SLUG_RECAP } from '../styles/slugs';
import { appendCommitHash } from '../utils/appendHash';

export const Delivery = () => {
  const { cart } = useCartContext();
  const navigate = useNavigate();
  const { accountAddress, address, addressSelected, setAddressSelected } =
    useAddressContext();

  useEffect(() => setAddressSelected('WINA'), [setAddressSelected]);

  useEffect(() => {
    if (cart.items.filter((i) => i.dematerialized === 0).length === 0) {
      navigate(appendCommitHash(`/${SLUG_RECAP}`));
    }
  }, [cart.items, navigate]);

  if (!accountAddress) return null;

  const isNotDemat =
    cart.items.filter((i) => i.dematerialized === 0).length > 0;

  return (
    <Wrapper>
      <CustomNav
        label={__('Delivery')}
        navStyle={'chevron'}
        forceDesktopLabelCenter
      />
      <WxText
        text={__('Where would you like to receive your order?')}
        darkMode
      />
      <DivSelector>
        <WxSelector
          label={__('Winamax account address')}
          onSelect={() => {
            setAddressSelected('WINA');
          }}
          selected={addressSelected === 'WINA'}
        />
        <WxSelector
          label={__('Other address')}
          onSelect={() => {
            setAddressSelected('CUSTOM');
          }}
          selected={addressSelected === 'CUSTOM'}
        />
      </DivSelector>
      {addressSelected === 'WINA' ? (
        <DivAddress>
          {isNotDemat && (
            <div>
              <WxLabel label={__('Address')} active />
              <AddressDisplay address={accountAddress} />
            </div>
          )}
        </DivAddress>
      ) : (
        <AddressForm isNotDemat={isNotDemat} />
      )}
      <OrderBar
        recapCheck={true}
        label={addressSelected === 'WINA' ? __('Confirm delivery') : __('Save')}
        active={
          addressSelected === 'WINA' ||
          (addressSelected === 'CUSTOM' &&
            (address.zipcode ? true : false) &&
            (address.city ? true : false))
        }
        onClick={() => navigate(appendCommitHash(`/${SLUG_RECAP}`))}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  overflow-x: hidden;
`;

const DivSelector = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.625rem;

  margin-block: 0.625rem 2.5rem;

  @media (min-width: ${breakpoint}) {
    flex-direction: row;
    margin-block: 1.25rem 3.75rem;

    > * {
      min-height: 150px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 50%;
    }
  }
`;

export const DivAddress = styled.div`
  > div {
    > :first-child {
      margin-bottom: 1.25rem;
    }

    margin-bottom: 2.8rem;
  }
`;
